import { Timber } from '@timberio/browser';

const logger = process.env.REACT_APP_TIMBER_API_KEY && process.env.REACT_APP_TIMBER_SOURCE
  ? new Timber(process.env.REACT_APP_TIMBER_API_KEY, process.env.REACT_APP_TIMBER_SOURCE)
  : console;

export default logger;
